module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "go"
  }, [_c('span', {
    staticClass: "back"
  }, [_c('img', {
    staticStyle: {
      "left": "0",
      "top": "7px",
      "position": "absolute"
    },
    attrs: {
      "src": require("../assets/back.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mytitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9bacfe6"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xtitle.vue
// module id = 280
// module chunks = 0